import { GridValidRowModel, DataGridProProps } from '@mui/x-data-grid-pro';
import { ReactNode } from 'react';
import { Union } from 'ts-toolbelt';

import { LineItemNegotiationCaseAssignments } from '../../../DemandAwardingWidget.hooks';
import {
  DemandAwardingData,
  DemandAwardingSettings,
  DemandAwardingStatus,
  Demand,
  DemandNegotiationCase,
} from '../../../DemandAwardingWidget.types';
import { TsrctAwardingStatusEntityVariant, TsrctAwardingStatusField, TsrctStatus } from '@/generated/gql/graphql.ts';

export interface UseAwardingDataGridLineItemBiddingProps {
  negotiationCases?: Union.Nullable<DemandAwardingData[]>;
  awardingSettings?: Union.Nullable<DemandAwardingSettings>;
  status?: Union.Nullable<DemandAwardingStatus[]>;
  demand?: Union.Nullable<Demand>;
  awardableConfirmedQuotes: boolean;
  lineItemAssignments: LineItemNegotiationCaseAssignments;
}
export interface AwardingDataGridRow {
  id: string;
  path: string[];
  type: AwardingDataGridRowType;
  renderLabelCell?: () => ReactNode;
  renderContentCell?: (negotiationCase: DemandNegotiationCase) => ReactNode;
  getContentCellClassName?: (negotiationCase: DemandNegotiationCase) => string;
}

export type UseAwardingDataGridLineItemBiddingConfig<R extends GridValidRowModel = any> = (
  props: UseAwardingDataGridLineItemBiddingProps,
) => Pick<
  DataGridProProps<R>,
  | 'rows'
  | 'columns'
  | 'pinnedRows'
  | 'initialState'
  | 'groupingColDef'
  | 'getTreeDataPath'
  | 'isRowSelectable'
  | 'columnHeaderHeight'
>;

export enum AwardingDataGridField {
  ID = 'id',
  PRIORITY = 'priority',
}

export enum AwardingDataGridGroupType {
  STATUS = 'grpStatus',
  QUOTE = 'grpQuote',
  LINE_ITEMS = 'grpLineItems',
  SUPPLIER = 'grpSupplier',
}

export type AwardingDataGridGroup = `${AwardingDataGridGroupType}`;

export enum AwardingDataGridRowType {
  AWARD_ALL_ITEMS = 'awardAllItems',
  SUPPLIER = 'supplier',
  PROCESSED_BY = 'processedBy',
  STATUS = 'status',
  PROCESS_STATUS = 'processStatus',
  SUPPLIER_REFERENCE = 'supplierReference',
  DELIVERY_TIME_FRAME = 'deliveryTimeFrame',
  INITIAL_TOTAL = 'initialTotal',
  DISCOUNT = 'discount',
  FINAL_TOTAL = 'finalTotal',
  FINAL_TOTAL_WITH_TAXES = 'finalTotalWithTaxes',
  LINE_ITEM = 'lineItem',
  QUANTITY = 'quantity',
  PRICE_PER_UNIT = 'pricePerUnit',
  TOTAL_VALUE = 'totalValue',
  TOTAL_SPEND_PAST_YEAR = 'totalSpendPastYear',
  ORDERS_PAST_YEAR = 'ordersPastYear',
  ACTION = 'action',
  PURCHASE_ORDERS = 'purchaseOrders',
}

export type EntityStatusGetter = (args: {
  entityVariant: TsrctAwardingStatusEntityVariant;
  field: TsrctAwardingStatusField;
  entityId: string;
}) => TsrctStatus;
